import { useState, useEffect } from 'react';
import Cookies from 'js-cookie';

const INTRO_COOKIE_NAME = 'languewise_intro_shown';
const COOKIE_EXPIRY_DAYS = 365;

export const useIntroModal = () => {
  const [showIntroModal, setShowIntroModal] = useState(false);

  useEffect(() => {
    const hasSeenIntro = Cookies.get(INTRO_COOKIE_NAME);
    if (!hasSeenIntro) {
      setShowIntroModal(true);
    }
  }, []);

  const closeIntroModal = () => {
    Cookies.set(INTRO_COOKIE_NAME, 'true', { expires: COOKIE_EXPIRY_DAYS });
    setShowIntroModal(false);
  };

  return {
    showIntroModal,
    closeIntroModal
  };
};
